import { render, staticRenderFns } from "./TrustedBySection.vue?vue&type=template&id=830c5580&"
import script from "./TrustedBySection.vue?vue&type=script&lang=js&"
export * from "./TrustedBySection.vue?vue&type=script&lang=js&"
import style0 from "./TrustedBySection.vue?vue&type=style&index=0&id=830c5580&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports